import React, { FC } from 'react';
import Icon from '../../../@shared/icon';
import { THeroSectionCarouselArrowProps } from './index.types';

const HeroSectionCarouselArrow: FC<THeroSectionCarouselArrowProps> = ({ direction, onClick }) => {
  const icon = 'arrow-chevron-' + (direction === 'previous' ? 'left' : 'right');
  return (
    <button
      className={'product-hero-section-carousel__arrow-control product-hero-section-carousel__arrow-control--' + direction}
      aria-label={direction + 'slide / item'}
      onClick={onClick}
    >
      <Icon iconName={icon as 'arrow-chevron-left' | 'arrow-chevron-right'} size={24} color="primary" />
    </button>
  );
};

export default HeroSectionCarouselArrow;
